export default __webpack_public_path__ + "static/media/coin.29332546.png";